import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ["button", "close", "dropdown"]

  connect() {
    this.dropdownTarget.classList.add("hidden")
  }

  select(event) {
    this._close()
  }

  hide(event) {
    if (!this.isActive()) {
      return
    }

    // Allow hiding on click outside menu, or on close button inside menu target
    if (event && (this.dropdownTarget.contains(event.target) || this.buttonTarget.contains(event.target))) {
      if (this.hasCloseTarget) {
        if (!this.closeTarget.contains(event.target)) {
          return;
        }
      } else {
        return
      }
    }

    if (event) {
      event.preventDefault()
    }

    this._close()
  }

  _close() {
     this.dropdownTarget.classList.add("hidden")
  }

  show(event) {
    //if (event && (this.dropdownTarget.contains(event.target) || this.buttonTarget.contains(event.target))) {
    //  return;
    //}
    if (event) {
      event.preventDefault()
    }

    this.dropdownTarget.classList.remove("hidden")
  }

  toggleMenu(event) {
    event.preventDefault();

    if (this.isActive()) {
      this.hide()
    } else {
      this.show()
    }
  }

  isActive() {
    return this.dropdownTarget.classList.contains("hidden") === false
  }
}
